import { Opportunity, TransactionTeam } from '@repo/services';

/**
 * Maps opportunity priority values (Low/Medium/High) to their corresponding health indicator label and color, used to render priority as a health status badge.
 */
export const priorityToHealthData = [
  { value: "Low", label: "Green", color: "green"},
  { value: "Medium", label: "Yellow", color: "yellow" },
  { value: "High", label: "Red", color: "red" },
]

/**
 * Lookup list mapping health status values (Green/Yellow/Red) to their display label and color.
 */
export const healthDataMap = [
  { value: "Green", label: "Green", color: "green"},
  { value: "Yellow", label: "Yellow", color: "yellow" },
  { value: "Red", label: "Red", color: "red" },
]

/**
 * Dollar amount above which a transaction requires IEC (Investment Executive Committee) approval.
 */
export const iecApprovalThreshold = 15000000;
/**
 * Dollar amount above which a deal is flagged as a high-value deal.
 */
export const highValueDealThreshold = 5000000;

/**
 * Low-value cutoff (USD) below which leads flagged `validForTransactionLeadLowValue`
 * become eligible as Transaction Lead (in addition to the standard
 * `validForTransactionLead` pool). The threshold is exclusive: a transaction priced
 * exactly at this amount is NOT considered low-value. Change here if the business
 * rule changes.
 */
export const lowValueTransactionLeadThresholdUsd = 250_000;

/**
 * Enum of valid transaction team role identifiers used for team member assignment and role checking.
 */
export enum TransactionTeamRoles {
  land = 'land',
  finance = 'finance',
  operations = 'operations'
}